var _rect, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPhysiotherapyIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 42,
    viewBox: "0 0 42 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 42,
    height: 42,
    rx: 9,
    fill: "url(#paint0_linear_19908_33428)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_19908_33428)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.4478 29.1069H10.6478V36.36C10.6478 36.7134 10.9376 37 11.2958 37H22.3656C22.7238 37 23.0136 36.7134 23.0136 36.36V29.1069H23.2136C23.5718 29.1069 23.8616 28.8203 23.8616 28.4669C23.8616 27.7437 23.6082 27.0834 23.1971 26.5469H24.4944L28.4122 33.7684C28.8109 34.5047 29.7493 35.0597 30.5948 35.0597C31.1517 35.0597 31.6604 34.7813 31.9554 34.315C32.2502 33.8487 32.28 33.2753 32.0357 32.781L27.5592 23.7222C27.1111 22.8138 26.16 22.2269 25.1361 22.2269H21.2696V17.2134H27.8471C28.9336 17.2134 29.8177 16.3403 29.8177 15.2669C29.8177 14.1934 28.9336 13.32 27.8471 13.32H15.778C14.3485 13.32 13.186 14.4684 13.186 15.8801V23.1869C13.186 23.9761 13.4744 24.6929 13.9372 25.2669H13.0398C11.2534 25.2669 9.7998 26.7025 9.7998 28.4669C9.7998 28.8203 10.0896 29.1069 10.4478 29.1069ZM21.7176 35.72H11.9438V29.1069H21.7176V35.72ZM14.482 23.1869V15.8801C14.482 15.1741 15.0635 14.6001 15.778 14.6001H27.8471C28.2192 14.6001 28.5217 14.899 28.5217 15.2669C28.5217 15.6344 28.2192 15.9334 27.8471 15.9334H20.6216C20.2634 15.9334 19.9736 16.22 19.9736 16.5734V22.8669C19.9736 23.2203 20.2634 23.5069 20.6216 23.5069H25.1361C25.6676 23.5069 26.1619 23.8116 26.3948 24.2831L30.8713 33.3426C30.9365 33.4745 30.8897 33.5838 30.8561 33.6369C30.8219 33.6903 30.7435 33.7797 30.5948 33.7797C30.2315 33.7797 29.7265 33.4806 29.5551 33.1644L25.4538 25.6047C25.3405 25.3966 25.1209 25.2669 24.8823 25.2669H20.6216H16.588C15.4268 25.2669 14.482 24.3338 14.482 23.1869ZM13.0398 26.5469H16.588H20.6216C21.4664 26.5469 22.1872 27.0819 22.4548 27.8269H22.3656H11.2958H11.2066C11.4742 27.0819 12.195 26.5469 13.0398 26.5469ZM18.046 12.4669C20.1305 12.4669 21.8258 10.7922 21.8258 8.73345C21.8258 6.67471 20.1305 5 18.046 5C15.9615 5 14.2656 6.67471 14.2656 8.73345C14.2656 10.7922 15.9615 12.4669 18.046 12.4669ZM18.046 6.28C19.4154 6.28 20.5298 7.38061 20.5298 8.73345C20.5298 10.0862 19.4154 11.1869 18.046 11.1869C16.676 11.1869 15.5616 10.0862 15.5616 8.73345C15.5616 7.38061 16.676 6.28 18.046 6.28Z",
    fill: "#B53657",
    stroke: "#B53657",
    strokeWidth: 0.2
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_19908_33428",
    x1: 21,
    y1: 0,
    x2: 21,
    y2: 42,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFC4D5"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_19908_33428"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white",
    transform: "translate(5 5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhysiotherapyIcon);
export default __webpack_public_path__ + "static/media/PhysiotherapyIcon.4d097fd98fdc448a5d04629e549eb989.svg";
export { ForwardRef as ReactComponent };